import { index, integer, jsonb, pgTable, smallint, text, timestamp, unique, uuid, vector, } from "drizzle-orm/pg-core";
import { organisations } from "./organisations";
export var EmbeddingKind;
(function (EmbeddingKind) {
    EmbeddingKind["DOCUMENT"] = "document";
    EmbeddingKind["EVENT"] = "event";
    EmbeddingKind["INSIGHT"] = "insight";
    EmbeddingKind["EMAIL"] = "email";
    EmbeddingKind["CHAT"] = "chat";
    EmbeddingKind["CHAT_SUMMARY"] = "chat_summary";
    EmbeddingKind["INTEGRATION_MESSAGING_SUMMARY"] = "integration_messaging_summary";
    EmbeddingKind["WEBSITE_PAGE"] = "website_page";
    EmbeddingKind["BRIEF"] = "brief";
})(EmbeddingKind || (EmbeddingKind = {}));
export var EmbeddingSourceType;
(function (EmbeddingSourceType) {
    EmbeddingSourceType["NOTION"] = "notion";
    EmbeddingSourceType["GOOGLE_DRIVE"] = "google_drive";
    EmbeddingSourceType["STRIPE"] = "stripe";
    EmbeddingSourceType["POSTHOG"] = "posthog";
    EmbeddingSourceType["GITHUB"] = "github";
    EmbeddingSourceType["LINEAR"] = "linear";
    EmbeddingSourceType["GMAIL"] = "gmail";
    EmbeddingSourceType["GCAL"] = "gcal";
    EmbeddingSourceType["EMAIL"] = "email";
    EmbeddingSourceType["INTERNAL"] = "internal";
    EmbeddingSourceType["OTHER"] = "other";
    EmbeddingSourceType["WEBSITE"] = "website";
    EmbeddingSourceType["DOCUMENT"] = "document";
})(EmbeddingSourceType || (EmbeddingSourceType = {}));
export const embeddings = pgTable("embeddings", {
    id: uuid("id").primaryKey().defaultRandom(),
    companyId: uuid("company_id")
        .notNull()
        .references(() => organisations.id, { onDelete: "cascade" }),
    // what this vector is for
    kind: text("kind").notNull().$type(), // 'document', 'event', 'insight', 'email', 'chat', etc.
    sourceType: text("source_type").notNull().$type(), // 'notion', 'stripe', 'posthog', 'lucien_insight', ...
    sourceId: text("source_id"), // original row/id in the source system
    chunkIndex: integer("chunk_index").notNull().default(0), // for chunked docs/events
    // actual text we embedded
    content: text("content").notNull(),
    metadata: jsonb("metadata").notNull().default({}),
    // embedding info
    embedding: vector("embedding", { dimensions: 1536 }).notNull(),
    embeddingModel: text("embedding_model").notNull().default("text-embedding-3-small"), // e.g. 'text-embedding-3-small'
    embeddingVersion: smallint("embedding_version").notNull().default(1), // increment when you migrate models
    expiresAt: timestamp("expires_at", { withTimezone: true }),
    createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
    updatedAt: timestamp("updated_at", { withTimezone: true })
        .notNull()
        .defaultNow()
        .$onUpdate(() => new Date()),
}, table => ({
    companyKindIndex: index("idx_embeddings_company_kind").on(table.companyId, table.kind),
    companySourceTypeIndex: index("idx_embeddings_company_source_type").on(table.companyId, table.sourceType),
    metadataGinIndex: index("idx_embeddings_metadata_gin").using("gin", table.metadata),
    // Vector index (IVFFlat) for cosine similarity
    embeddingIvfflatIndex: index("idx_embeddings_vec")
        .using("ivfflat", table.embedding.op("vector_cosine_ops"))
        .with({ lists: 100 }),
    expiresAtIdx: index("idx_embeddings_expires_at").on(table.expiresAt),
    uniqueChatSummary: unique("unique_chat_summary_per_conversation").on(table.companyId, table.kind, table.sourceId, table.chunkIndex),
}));
